import { z } from 'zod';
export const DEFAULT_BASE_DOMAIN = 'xss.cool';
// Single DNS label: lowercase letters, digits, hyphen; 1-63 chars; not at boundary.
export const subdomainLabel = z
    .string()
    .regex(/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/);
export const domainSelectionSchema = z.object({
    base: z.string().min(1),
    sub: z.string().optional(),
});
export const appConfigSchema = z.object({
    domains: z.array(z.string().min(1)).min(1),
    repoUrl: z.string().nullable().optional(),
});
export function isValidSubdomain(s) {
    return subdomainLabel.safeParse(s).success;
}
// Compute the host (no scheme, no port, no path) from a selection.
export function hostFromSelection(input) {
    const base = input.base.trim();
    const sub = (input.sub ?? '').trim();
    return sub ? `${sub}.${base}` : base;
}
